import { httpClient } from './http';

export type PromotionImage = { url: string; alt?: string | null };

export type Promotion = {
  id: string;
  restaurant_id: string;
  title: string;
  description?: string | null;
  images?: PromotionImage[];
  type: 'generic' | 'discount' | 'bundle' | 'happy_hour';
  config?: Record<string, any>;
  start_at?: string | null;
  end_at?: string | null;
  enabled: boolean;
  metadata?: Record<string, any>;
  created_at?: string;
  updated_at?: string;
};

export const promotionsService = {
  async list(userId: string, restaurantId: string) {
    return httpClient.get(`/system/users/${userId}/restaurants/${restaurantId}/promotions`, undefined, 'authenticated');
  },
  async listActive(restaurantId: string) {
    return httpClient.get(`/restaurants/${restaurantId}/promotions/active`, undefined, 'public');
  },
  async get(userId: string, restaurantId: string, id: string) {
    return httpClient.get(`/system/users/${userId}/restaurants/${restaurantId}/promotions/${id}`, undefined, 'authenticated');
  },
  async create(userId: string, restaurantId: string, data: Partial<Promotion> & { imagesFilenames?: { filename: string }[] }) {
    return httpClient.post(`/system/users/${userId}/restaurants/${restaurantId}/promotions`, data, 'authenticated');
  },
  async update(userId: string, restaurantId: string, id: string, data: Partial<Promotion>) {
    return httpClient.put(`/system/users/${userId}/restaurants/${restaurantId}/promotions/${id}`, data, 'authenticated');
  },
  async remove(userId: string, restaurantId: string, id: string) {
    return httpClient.delete(`/system/users/${userId}/restaurants/${restaurantId}/promotions/${id}`, 'authenticated');
  },
};


